<template>
  <t-form labelWidth="100px">
    <e-collapse title="样式配置" :expand="false">
      <div class="formItemDiv">边框样式：</div>
      <t-row>
        <t-col :span="6" v-for="(item, index) in borderTypes" :key="item.value">
          <div
            style="height: 80px; overflow: hidden; cursor: pointer"
            @click="onStyleBorder(item)"
          >
            <component :is="item.value" style="height: 80px" />
          </div>
        </t-col>
      </t-row>
      <t-form-item label="边框颜色1">
        <t-color-picker
          :colorModes="['monochrome']"
          format="RGBA"
          size="small"
          v-model="attribute.borderColor1"
          enableAlpha
        />
      </t-form-item>
      <t-form-item label="边框颜色2">
        <t-color-picker
          :colorModes="['monochrome']"
          format="RGBA"
          size="small"
          v-model="attribute.borderColor2"
          enableAlpha
        />
      </t-form-item>
      <t-form-item label="背景颜色">
        <t-color-picker
          :colorModes="['monochrome']"
          format="RGBA"
          size="small"
          v-model="attribute.backgroundColor"
          enableAlpha
        />
      </t-form-item>
      <div v-if="attribute.borderType === 'dv-border-box-8'">
        <t-form-item label="动画时长">
          <t-input-number
            size="small"
            v-model="attribute.dur"
            :min="1"
            :max="60"
            :decimal-places="0"
          />
        </t-form-item>
        <t-form-item label="动画方向">
          <t-select
            size="small"
            v-model="attribute.reverse"
            placeholder="请选择"
          >
            <t-option label="逆时针" :value="true" />
            <t-option label="顺时针" :value="false" />
          </t-select>
        </t-form-item>
      </div>
      <div v-if="attribute.borderType === 'dv-border-box-11'">
        <t-form-item label="标题">
          <t-input size="small" v-model="attribute.borderTitle" />
        </t-form-item>
        <t-form-item label="标题宽度">
          <t-input-number
            size="small"
            v-model="attribute.titleWidth"
            :min="10"
            :max="1200"
            :decimal-places="0"
          />
        </t-form-item>
      </div>
    </e-collapse>
    <e-collapse title="生成九宫格配置" :expand="true">
      <t-form-item label="单元格模式">
        <t-switch
          v-model="attribute.switchGrid"
          @change="onChange"
          size="small"
          :label="['开', '关']"
        />
      </t-form-item>

      <t-form-item label="列">
      <t-input-number
        v-model="attribute.colNum"
        :max="100"
        style="width: 90%"
      />
      </t-form-item>
      <t-form-item label="行" v-show="!attribute.paginationFlag">
        <t-input-number
          v-model="attribute.rowNum"
          :max="100"
          style="width: 90%"
        />
      </t-form-item>
      <t-form-item label="格子上下间距">
        <t-input-number
          v-model="attribute.gridSpace"
          :max="1000"
          style="width: 90%"
        />
      </t-form-item>
      <t-form-item label="上边距">
        <t-input-number
          v-model="attribute.topSpace"
          :max="1000"
          style="width: 90%"
        />
      </t-form-item>
      <t-form-item label="左边距">
        <t-input-number
          v-model="attribute.leftSpace"
          :max="1000"
          style="width: 90%"
        />
      </t-form-item>
      <t-form-item label="右边距">
        <t-input-number
          v-model="attribute.rightSpace"
          :max="1000"
          style="width: 90%"
        />
      </t-form-item>
      <t-form-item label="动态生成格子">
        <t-switch
          v-model="attribute.isCreatGridByData"
          size="small"
          :label="['开', '关']"
        />
      </t-form-item>
      <!-- <t-form-item label="高度">
      <t-radio-group v-model="attribute.gridHeight" size="small">
        <t-radio-button value="regular">固定</t-radio-button>
        <t-radio-button value="auto">自动</t-radio-button>
      </t-radio-group>
    </t-form-item> -->
      <t-button
        v-show="!attribute.isCreatGridByData"
        style="width: 100%; margin-top: 20px"
        @click="creatGrid"
        >生成九宫格</t-button
      >
    </e-collapse>
    <!-- <e-collapse title="分页配置" :expand="false">
      <t-form-item label="显示分页">
        <t-switch
          v-model="attribute.switchGrid"
          @change="onChange"
          size="small"
          :label="['开', '关']"
        />
      </t-form-item>
    </e-collapse>
    <e-collapse title="按钮组配置" :expand="false">
      <t-form-item label="显示按钮组">
        <t-switch
          v-model="attribute.switchGrid"
          @change="onChange"
          size="small"
          :label="['开', '关']"
        />
      </t-form-item>
    </e-collapse>
    <e-collapse title="合计配置" :expand="false">
    </e-collapse> -->
    <e-collapse title="锁定配置" :expand="false">
      <t-form-item label="锁定九宫格">
        <t-switch
          v-model="attribute.isLock"
          size="small"
          :label="['开', '关']"
        />
      </t-form-item>
    </e-collapse>

    <e-collapse title="弹窗配置" :expand="false">
      <t-form-item label="用作弹窗">
        <t-switch
          v-model="attribute.isPop"
          size="small"
          @change="onChange"
          :label="['开', '关']"
        />
      </t-form-item>
    </e-collapse>
    <e-collapse title="子数据集关系配置" :expand="false">
      <t-form-item label="是否包含子数据集">
        <t-switch
          v-model="attribute.hasSubDataset"
          size="small"
          :label="['开', '关']"
        />
      </t-form-item>
    </e-collapse>
    <e-collapse title="数据分组" :expand="false">
      <t-form-item label="是否数据分组">
        <t-switch
          v-model="attribute.dataGroup"
          size="small"
          :label="['开', '关']"
        />
      </t-form-item>
    </e-collapse>
    <e-collapse title="勾选配置" :expand="false">
      <t-form-item label="默认开启勾选">
        <t-switch
          v-model="attribute.isShowCheckBox"
          size="small"
          :label="['开', '关']"
        />
      </t-form-item>
    </e-collapse>
    <e-collapse title="分页配置" :expand="false">
      <t-form-item label="开启分页">
        <t-switch
          v-model="attribute.paginationFlag"
          size="small"
          :label="['开', '关']"
        />
      </t-form-item>
      <t-form-item label="分页方式" v-if="attribute.paginationFlag">
        <t-radio-group v-model="attribute.paginationType" size="small">
          <t-radio :value="1">分页控件</t-radio>
          <t-radio :value="2">加载更多</t-radio>
          <t-radio :value="3">上拉加载更多</t-radio>
        </t-radio-group>
      </t-form-item>
      <t-form-item label="分页模式" v-if="attribute.paginationFlag">
        <t-radio-group v-model="attribute.paginationMode" size="small">
          <t-radio :value="false">前端分页</t-radio>
          <t-radio :value="true">后端分页</t-radio>
        </t-radio-group>
      </t-form-item>
      <t-form-item label="上拉加载阀值" v-if="attribute.paginationType == 3">
        <t-input-number
          v-model="attribute.reachBottom"
          :max="1000"
          style="width: 90%"
        />
      </t-form-item>

      <!-- <t-form-item label="页码">
        <t-input-number
          v-model="attribute.pageNo"
          :max="100"
          style="width: 90%"
        />
      </t-form-item>
      <t-form-item label="页数">
        <t-input-number
          v-model="attribute.pageSize"
          :max="100"
          style="width: 90%"
        />
      </t-form-item> -->
      <t-form-item label="默认页容量" v-if="attribute.paginationFlag">
        <t-select v-model="attribute.pageSize" size="small">
          <t-option label="1" :value="1" />
          <t-option label="2" :value="2" />
          <t-option label="5" :value="5" />
          <t-option label="10" :value="10" />
          <t-option label="20" :value="20" />
          <t-option label="50" :value="50" />
        </t-select>
      </t-form-item>
    </e-collapse>
    <e-collapse
      title="按钮配置"
      :expand="false"
      v-if="attribute.paginationType == 2"
    >
      <e-collapse title="基础设置" :expand="false">
        <t-form-item label="宽度">
          <t-input-number
            v-model="attribute.btnWidth"
            :min="10"
            :max="12048"
          />
        </t-form-item>
        <t-form-item label="高度">
          <t-input-number
            v-model="attribute.btnHeight"
            :min="10"
            :max="12048"
          />
        </t-form-item>
        <t-form-item label="上边距">
          <t-input-number
            size="small"
            v-model="attribute.btntop"
            theme="normal"
            align="left"
            :min="0"
            :max="9999"
            :decimal-places="0"
          >
            <template #suffix><span>px</span></template>
          </t-input-number>
        </t-form-item>
        <t-form-item label="下边距">
          <t-input-number
            size="small"
            v-model="attribute.btnbottom"
            theme="normal"
            align="left"
            :min="0"
            :max="9999"
            :decimal-places="0"
          >
            <template #suffix><span>px</span></template>
          </t-input-number>
        </t-form-item>
        <t-form-item label="背景颜色">
          <t-color-picker
            size="small"
            :colorModes="['monochrome']"
            format="RGBA"
            enableAlpha
            v-model="attribute.bgColor"
          />
        </t-form-item>
        <t-form-item label="显示加载态">
          <t-radio-group size="small" v-model="attribute.isShowLoading">
            <t-radio-button :value="1">是</t-radio-button>
            <t-radio-button :value="0">否</t-radio-button>
          </t-radio-group>
        </t-form-item>
      </e-collapse>
      <e-collapse title="字体设置" :expand="false">
        <t-form-item label="字体颜色">
          <t-color-picker
            size="small"
            :colorModes="['monochrome']"
            format="RGBA"
            enableAlpha
            v-model="attribute.textColor"
          />
        </t-form-item>
        <t-form-item label="字体样式">
          <t-radio-group size="small" v-model="attribute.fontStyle">
            <t-radio-button value="normal">正常</t-radio-button>
            <t-radio-button value="italic">斜体</t-radio-button>
          </t-radio-group>
        </t-form-item>
        <t-form-item label="加粗">
          <t-radio-group size="small" v-model="attribute.fontWeight">
            <t-radio-button value="normal">正常</t-radio-button>
            <t-radio-button value="bold">加粗</t-radio-button>
            <t-radio-button value="lighter">更细</t-radio-button>
          </t-radio-group>
        </t-form-item>
        <t-form-item label="字体">
          <t-select size="small" v-model="attribute.fontFamily">
            <t-option
              v-for="item in textFamilyList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </t-select>
        </t-form-item>
        <t-form-item label="字体大小">
          <t-input-number
            size="small"
            :min="0"
            :max="9999"
            v-model="attribute.fontSize"
            :decimal-places="0"
          />
        </t-form-item>
      </e-collapse>
      <e-collapse title="边框设置" :expand="false">
        <t-form-item label="边框宽度">
          <t-input-number
            size="small"
            v-model="attribute.borderSize"
            :min="0"
            :max="9999"
            :decimal-places="0"
          />
        </t-form-item>
        <t-form-item label="边框颜色">
          <t-color-picker
            size="small"
            :colorModes="['monochrome']"
            format="RGBA"
            enableAlpha
            v-model="attribute.borderColor"
          />
        </t-form-item>
        <t-form-item label="边框左上圆角">
          <t-input-number
            size="small"
            v-model="attribute.borderTopLeftRadius"
            :min="0"
            :max="9999"
            :decimal-places="0"
          />
        </t-form-item>
        <t-form-item label="边框左下圆角">
          <t-input-number
            size="small"
            v-model="attribute.borderBottomLeftRadius"
            :min="0"
            :max="9999"
            :decimal-places="0"
          />
        </t-form-item>
        <t-form-item label="边框右上圆角">
          <t-input-number
            size="small"
            v-model="attribute.borderTopRightRadius"
            :min="0"
            :max="9999"
            :decimal-places="0"
          />
        </t-form-item>
        <t-form-item label="边框右下圆角">
          <t-input-number
            size="small"
            v-model="attribute.borderBottomRightRadius"
            :min="0"
            :max="9999"
            :decimal-places="0"
          />
        </t-form-item>
        <t-form-item label="线条类型">
          <t-select size="small" v-model="attribute.lineType">
            <t-option
              v-for="item in lineTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </t-select>
        </t-form-item>
      </e-collapse>
    </e-collapse>
    <e-collapse title="滚动条配置" :expand="false">
      <t-form-item label="开启滚动条">
        <t-switch
          v-model="attribute.isScroll"
          size="small"
          :label="['开', '关']"
        />
      </t-form-item>
      <t-form-item label="横向滚动条">
        <t-switch
          v-model="attribute.xScroll"
          size="small"
          :label="['开', '关']"
        />
      </t-form-item>
      <t-form-item label="纵向滚动条">
        <t-switch
          v-model="attribute.yScroll"
          size="small"
          :label="['开', '关']"
        />
      </t-form-item>
    </e-collapse>
    <e-collapse title="默认选中配置" :expand="false">
      <t-form-item label="选中第一个">
        <t-switch
          v-model="attribute.checkFirst"
          size="small"
          :label="['开', '关']"
        />
      </t-form-item>
      <t-form-item label="选中边框宽度">
        <t-input-number
          v-model="attribute.checkWidth"
          :max="100000"
          style="width: 90%"
        />
      </t-form-item>
      <t-form-item label="选中边框颜色">
        <t-color-picker
          :colorModes="['monochrome']"
          format="HEX"
          v-model="attribute.checkColor"
          size="small"
        />
      </t-form-item>
    </e-collapse>
    <t-form-item label="是否缓存">
      <t-radio-group v-model="cptDataForm.isCache" size="small">
        <t-radio :value="false">开启</t-radio>
        <t-radio :value="true">关闭</t-radio>
      </t-radio-group>
    </t-form-item>
  </t-form>
</template>

<script>
export default {
  name: "cpt-ninegrid-option",
  props: {
    attribute: Object,
    currentCpt: Object,
    refMap: Object,
    cptDataForm: Object,
  },
  data() {
    return {
      borderTypes: [
        { value: "dv-border-box-1", label: "样式1" },
        { value: "dv-border-box-2", label: "样式2" },
        { value: "dv-border-box-3", label: "样式3" },
        { value: "dv-border-box-4", label: "样式4" },
        { value: "dv-border-box-5", label: "样式5" },
        { value: "dv-border-box-6", label: "样式6" },
        { value: "dv-border-box-7", label: "样式7" },
        { value: "dv-border-box-8", label: "样式8" },
        { value: "dv-border-box-9", label: "样式9" },
        { value: "dv-border-box-10", label: "样式10" },
        /*{ value: 'dv-border-box-11', label: '样式11' },大量使用时会导致GPU资源占用过高*/
        { value: "dv-border-box-12", label: "样式12" },
        { value: "dv-border-box-13", label: "样式13" },
      ],
      textFamilyList: [],
      lineTypeList: [],
    };
  },
  watch: {
    "attribute.paginationFlag": {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue) {
          this.attribute.isScroll = true;
          this.attribute.yScroll = true;
          this.cptDataForm.isCache = true;
        }
      },
    },
    "attribute.paginationType": {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue == 2) {
          this.textFamilyList = require("@/assets/font/font-list");
          this.lineTypeList = require("@/assets/data/line-type");
        }
      },
      immediate: true 
    },
  },
  mounted() {
    // let vm = this;
    // // 是否是弹窗,
    // const isPop = vm.currentCpt.cptOption.attribute.isPop;
    // isPop ? document.getElementById(vm.currentCpt.id).style.display = "none" : document.getElementById(this.currentCpt.id).style.display = "block";
  },
  methods: {
    onStyleBorder(item) {
      this.attribute.borderType = item.value;
    },
    onChange(val) {
      let vm = this;
      // 是否是弹窗,
      const { isPop, isScroll } = vm.attribute;
      let sonWidth = 0;
      // 弹窗设置生成1*1九宫格
      vm.currentCpt.group.forEach((gid, index) => {
        // 显示外层弹窗并修改外层框宽度
        if (index == 0 && isPop) {
          sonWidth = vm.refMap[gid].current.divWidth;
          vm.refMap[vm.currentCpt.id].current.cptWidth = sonWidth;
          if (!isScroll) {
            const divHeight =
              vm.refMap[gid].current.cptHeight + this.attribute.topSpace;
            vm.refMap[vm.currentCpt.id].current.cptHeight = divHeight;
            // vm.refMap[vm.currentCpt.id].current.cptX = cptX;
            // vm.refMap[vm.currentCpt.id].current.cptY = cptY;
          }
          // document.getElementById(vm.currentCpt.id).style.width =  sonWidth + 'px';
        }
        if (
          vm.refMap[gid].current &&
          vm.refMap[gid].current.cptType == "ngcombination-border"
        ) {
          vm.refMap[gid].current.cptOption.attribute.switchGrid = val;
        }
      });
      // val && !isPop ? document.getElementById(this.currentCpt.id).style.display = "none" : document.getElementById(this.currentCpt.id).style.display = "block";
      val
        ? (document.getElementById(this.currentCpt.id).style.display = "none")
        : (document.getElementById(this.currentCpt.id).style.display = "block");
      // val ? document.getElementById(this.currentCpt.id).style.visibility = "hidden" : document.getElementById(this.currentCpt.id).style.visibility = "visible";
      for (const key in vm.currentCpt.tabGroup) {
        const regex = /-\d+/; // 匹配破折号后跟随的一个或多个数字
        const match = key.match(regex);
        var extractedNumber;
        if (match) {
          extractedNumber = Number(match[0].substring(1)); // 去掉破折号
          // console.log(extractedNumber); // 输出：0
        }
        if (extractedNumber > 0) {
          this.currentCpt.tabGroup[key].forEach((id) => {
            if (
              document.getElementById(id) &&
              document.getElementById(id).style
            ) {
              val && !isPop
                ? (document.getElementById(id).style.display = "none")
                : (document.getElementById(id).style.display = "block");
            }
          });
        }
      }
      isPop ? vm.creatGrid() : null;
    },
    creatGrid() {
      this.$emit("creatGrid", this.attribute);
    },
  },
};
</script>

<style scoped>
.formItemDiv {
  width: 100%;
  line-height: 30px;
  text-indent: 1em;
  font-size: 13px;
  color: var(--td-text-color-primary);
}
</style>
